const zIndex = 'zIndex' as const;

export const aliasZIndexBuiltIns = {
  zIndex,
} as const;

export const aliasZIndex = {
  ...aliasZIndexBuiltIns,
} as const;
